import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { Flip, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Componentes
import Sidebar from './components/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';

// Páginas
import Dashboard from './pages/Dashboard';
import Empresas from './pages/Empresas';
import Usuarios from './pages/Usuarios';
import UsuariosEmpresas from './pages/UsuariosEmpresas';
import CategoriasServicios from './pages/CategoriasServicios';
import Ciudades from './pages/Ciudades';
import Servicios from './pages/Servicios';
import Leads from './pages/leads/Leads_fixed';
import LeadsPartnes from './pages/Leads_partnes';
import Promociones from './pages/Promociones';
import CompanyProviders from './pages/CompanyProviders';
import Login from './pages/Login';
import Api_Stadistics from './pages/Api_Stadistics';

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Flip}
      />
      <Router>
        <Routes>
          {/* Ruta pública - Login */}
          <Route path="/login" element={<Login />} />

          {/* Ruta por defecto - Redirige a login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Rutas protegidas - Requieren autenticación */}
          <Route path="/*" element={
            <ProtectedRoute>
              <div className="flex min-h-screen bg-gray-100">
                {/* Sidebar */}
                <Sidebar />

                {/* Contenido principal */}
                <div className="flex-1">


                  <main className="p-6">
                    <Routes>
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="usuarios-empresas" element={<UsuariosEmpresas />} />
                      <Route path="empresas" element={<Empresas />} />
                      <Route path="usuarios" element={<Usuarios />} />
                      <Route path="categorias-servicios" element={<CategoriasServicios />} />
                      <Route path="ciudades" element={<Ciudades />} />
                      <Route path="servicios" element={<Servicios />} />
                      <Route path="leads" element={<Leads />} />
                      <Route path="leads_partnes" element={<LeadsPartnes />} />
                      <Route path="promociones" element={<Promociones />} />
                      <Route path="company-providers" element={<CompanyProviders />} />
                      <Route path="api-estadisticas" element={<Api_Stadistics />} />
                      <Route path="*" element={<Navigate to="dashboard" replace />} />
                    </Routes>
                  </main>
                </div>
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </>
  );
}

export default App;
